import { Component, OnInit } from '@angular/core';
import { ApiService, IdentityService, ProfileService } from '@app/core';
import { JwtService } from '@app/core/services/jwt.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { UserService } from '@app/core/services/user.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DeviceDetectorService } from '../../../node_modules/ngx-device-detector';
import { SpinnerVisibilityService } from 'ng-http-loader';

function sdobValidation(c: AbstractControl): any {
  if (!c.parent || !c) return;
  const inputSDOB = c.parent.get('sdob');
  if (!inputSDOB) return;
  var dtToday = new Date();
  var dDob = inputSDOB.value;
  if (dDob != undefined && dDob != null && dDob != '') {
    var date = new Date(dDob.year, dDob.month - 1, dDob.day);
    if (date.toString() == "Invalid Date") {
      console.log("Invalid Date");
      return { invalid: true };
    }
    if (dDob.year < 1900) {
      console.log("year less than 1900");
      return { invalid: true };
    }
    else
      if (date > dtToday) {
        console.log("date is greater than today");
        return { invalid: true };
      }
  }
}

function zipCustomValidation(c: AbstractControl): any {
  if (!c.parent || !c) return;
  const inputZip = c.parent.get('zipCode');
  if (!inputZip) return;
  if (inputZip.value) {
    if (inputZip.value.length == 5 || inputZip.value.length == 10) {
      return null;
    } else {
      return { invalid: true };
    }
  } else {
    return { invalid: true };
  }
}

function passwordConfirming(c: AbstractControl): any {
  if (!c.parent || !c) return;
  const pwd = c.parent.get('password');
  const cpwd = c.parent.get('confirmPassword')

  if (!pwd || !cpwd) return;
  if (pwd.value !== cpwd.value) {
    return { invalid: true };
  }
}

function lastNameCustomValidation(c: AbstractControl): any {
  if (!c.parent || !c) return;
  const inputLN = c.parent.get('lastName');
  if (!inputLN) return;
  var allowChar = ['JR', 'SR', 'I', 'II', 'II', 'IV', 'V', 'VI', 'VII', 'VIII'];
  var lName = inputLN.value.split(" ");
  if (lName.length == 2) {
    if (allowChar.indexOf(lName[1]) > -1) {
      return null;
    } else {
      return { invalid: true };
    }
  } else if (lName.length == 1) {
    return null;
  } else {
    return { invalid: true };
  }
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  editForm: FormGroup;
  resetPasswordForm: FormGroup;

  states = new Map([
    ['AB', 'ALBERTA'], ['BC', 'BRITISH COLUMBIA'], ['CZ', 'CANAL ZONE'], ['AB', 'ALBERTA'], ['MB', 'MANITOBA'], ['NB', 'NEW BRUNSWICK'], ['NF', 'NEWFOUNDLAND'],
    ['NT', 'NORTHWEST TERRITORY'],
    ['NS', 'NOVA SCOTIA'], ['ON', 'ONTARIO'], ['PE', 'PRINCE EDWARD ISLAND'], ['QC', 'QUEBEC'], ['SK', 'SASKATCHEWAN'], ['YT', 'YUKON TERRITORY'],
    ['GU', 'GUAM'], ['AL', 'ALABAMA'],
    ['AK', 'ALASKA'], ['AZ', 'ARIZONA'], ['AR', 'ARKANSAS'], ['CA', 'CALIFORNIA'], ['CO', 'COLORADO'], ['CT', 'CONNECTICUT'], ['DE', 'DELAWARE'], ['FL', 'FLORIDA'],
    ['GA', 'GEORGIA'], ['HI', 'HAWAII'], ['ID', 'IDAHO'], ['IL', 'ILLINOIS'], ['IN', 'INDIANA'], ['IA', 'IOWA'], ['KS', 'KANSAS'], ['KY', 'KENTUCKY'],
    ['LA', 'LOUISIANA'], ['MD', 'MARYLAND'], ['MA', 'MASSACHUSETTS'], ['MI', 'MICHIGAN'], ['MN', 'MINNESOTA'], ['MS', 'MISSISSIPPI'], ['MO', 'MISSOURI'], ['MT', 'MONTANA'],
    ['NE', 'NEBRASKA'], ['NV', 'NEVADA'], ['NH', 'NEW HAMPSHIRE'], ['NJ', 'NEW JERSEY'], ['NM', 'NEW MEXICO'], ['NY', 'NEW YORK'], ['NC', 'NORTH CAROLINA'],
    ['ND', 'NORTH DAKOTA'], ['OH', 'OHIO'], ['OK', 'OKLAHOMA'], ['OR', 'OREGON'], ['PA', 'PENNSYLVANIA'], ['PR', 'PUERTO RICO'], ['RI', 'RHODE ISLAND'],
    ['SC', 'SOUTH CAROLINA'], ['SD', 'SOUTH DAKOTA'], ['TN', 'TENNESSEE'], ['TX', 'TEXAS'], ['UT', 'UTAH'], ['VT', 'VERMONT'], ['VI', 'VIRGIN ISLANDS'],
    ['VA', 'VIRGINIA'], ['WA', 'WASHINGTON'], ['DC', 'WASHINGTON D.C.'], ['WV', 'WEST VIRGINIA'], ['WI', 'WISCONSIN'], ['WY', 'WYOMING'], ['ME', 'MAINE']
  ])

  countries: string[] = ['UNITED STATES', 'OTHER/NON-USA'];
  genders: string[] = ['M', 'F'];
  constructor(private formBuilder: FormBuilder,
    private apiService: ApiService,
    private userService: UserService,
    private identityService: IdentityService,
    private profileService: ProfileService,
    private jwtService: JwtService,
    private router: Router,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private spinner: SpinnerVisibilityService,
    private deviceService: DeviceDetectorService) {
    this.profileForm();
    this.loginForm();
  }

  country: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string;
  spouseDateOfBirth: string;
  homeTelephoneNo: string;
  workTelephoneNo: string;
  address1: string;
  address2: string;
  address3: string;
  state: string;
  zip: string;
  userName: string;
  is_Editable: boolean = false;
  is_Enable: boolean = false;
  message: string;
  userId: number;
  password: string;
  //currentParticipantID: String;
  Is_US: boolean;
  is_dropdownUS: boolean;
  isError: boolean = false;
  isLoginError : boolean = false;
  Role: string = this.jwtService.getUserRole();
  asterik: string;
  msgColor: string;
  profileMessage: string;
  profileAsterik: string;
  submitted = false;
  today: any;
  spDOB: string;

  stateCode: string;
  get cpwd() {
    return this.resetPasswordForm.get('confirmPassword');
  }

  ngOnInit() {
    var dt = new Date();
    this.today = {
      year: dt.getFullYear(), month: (dt.getMonth() + 1), day: (dt.getDate())
    };
    //this.currentParticipantID = this.jwtService.getParticipantId();
    this.spinner.show();
    this.getProfileData();
    var loggedInUser = this.jwtService.getLoggedInUser();
    this.userName = loggedInUser.username;
    this.userId = loggedInUser.id;
  }

  editLogin() {
    this.is_Enable = true;
  }
  cancelLogin() {
    this.is_Enable = false;
    this.resetPasswordForm.patchValue({
      password: null,
      confirmPassword: null
    });
    this.message = null;
    this.asterik = null;
  }

  changePassword() {
    var formData = this.resetPasswordForm.value;
    this.submitted = true;
    // stop here if form is invalid
    if (this.resetPasswordForm.invalid) {
      console.log("Inside Form Invalid Block");
      this.isLoginError = true;
      return;
    }
     //var data = { "userId": this.userId, "password": formData.password };
    var data = {"password": formData.password };
    console.log(data);

    this.userService.changePassword(data).subscribe(
      res => {
        console.log(data);

        this.message = res.message;
        console.log(res.message);
        this.asterik = '*';
        this.msgColor = 'green';
        this.password = formData.password;
        this.is_Enable = false;
        this.resetPasswordForm.patchValue({
          password: null,
          confirmPassword: null
        });
        setTimeout(function () {
          this.message = null;
          this.asterik = null;
        }.bind(this), 5000);
      },
      err => {
        this.message = err.errors.message;
        console.log(err.errors.message);

        this.asterik = '*';
        this.msgColor = 'red';
        this.resetPasswordForm.patchValue({
          password: null,
          confirmPassword: null
        });
      }
    );
  }
  Edit() {
    this.is_Editable = true;
  }
  cancel() {
    this.is_Editable = false;
    this.getProfileData();
  }

  save() {
    var proData = this.editForm.value;

    if (this.editForm.invalid) {
      console.log("Inside Form Invalid Block");
      this.isError = true;
      return;
    }
    this.profileService.profileUpdate(proData).subscribe(
      res => {
        if (res.code == '200') {

          this.firstName = proData.firstName;
          this.middleName = proData.middleName;
          this.lastName = proData.lastName;
          this.gender = proData.gender;
          this.spouseDateOfBirth = proData.sdob != null ? proData.sdob.year + '-' + proData.sdob.month + '-' + proData.sdob.day : "";
          this.homeTelephoneNo = proData.homephnum;
          this.workTelephoneNo = proData.workphnum;
          this.address1 = proData.address1;
          this.address2 = proData.address2;
          this.address3 = proData.address3;
          this.stateCode = proData.state;
          if (proData.state != null && proData.state != '') {
            this.state = this.states.get(proData.state);
          } else {
            this.state = '53';
          }
          this.zip = proData.zipCode;
          this.country = proData.country;
          this.profileMessage = res.message;
          this.profileAsterik = "*";
          this.msgColor = "green";
          setTimeout(function () {
            this.profileMessage = null;
            this.profileAsterik = null;
          }.bind(this), 5000);
          this.is_Editable = false;
        }
      },
      err => {
        this.profileMessage = err.errors.message;
        this.profileAsterik = '*';
        this.msgColor = 'red';
      }
    );
    return false;
  }



  onPasswordChange() {
    this.resetPasswordForm.patchValue({
      confirmPassword: null
    });

  }

  alphabetOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode === 8)) {
      return true;
    }
    return false;
  }
  onZipChange(value) {
    var position = 5;
    var output = [value.slice(0, position), '-', value.slice(position)].join('');
    if ((value.length >= 6) && !(value.includes("-"))) {
      this.editForm.patchValue({
        zipCode: output
      })
    }
  }
  lastAlphabetOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode === 8) || (charCode == 32)) {
      return true;
    }
    return false;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  getProfileData() {
    const browser = this.deviceService.browser;
    // const params = { "participantId": this.currentParticipantID };
    // return this.apiService.post("/profile", params).subscribe(
      return this.apiService.get("/profile").subscribe(

      data => {
        const ZipControl = this.editForm.get('zipCode');
        const StateControl = this.editForm.get('state');
        this.firstName = !data.data.participantVO.firstName ? data.data.participantVO.firstInitial : data.data.participantVO.firstName;
        this.middleName = data.data.participantVO.secondInitial;
        this.lastName = data.data.participantVO.lastName;
        this.gender = data.data.participantVO.gender;
        this.dateOfBirth = data.data.participantVO.dateOfBirth;
        this.spouseDateOfBirth = data.data.participantVO.spouseDateOfBirth;
        var spDOBDB = { year: null, day: null, month: null };
        if (this.spouseDateOfBirth != null && this.spouseDateOfBirth != '' && this.spouseDateOfBirth != undefined) {
          this.spDOB = this.spouseDateOfBirth.split('-')[1] + '/' + this.spouseDateOfBirth.split('-')[2] + '/' + this.spouseDateOfBirth.split('-')[0];
          spDOBDB.day = parseInt(this.spouseDateOfBirth.split('-')[2]);
          spDOBDB.month = parseInt(this.spouseDateOfBirth.split('-')[1]);
          spDOBDB.year = parseInt(this.spouseDateOfBirth.split('-')[0]);
        } else {
          this.spDOB = this.spouseDateOfBirth
          spDOBDB = null;
        }
        this.homeTelephoneNo = data.data.participantVO.homeTelephoneNo;
        this.workTelephoneNo = data.data.participantVO.workTelephoneNo;
        this.address1 = data.data.participantVO.addressLine1;
        this.address2 = ((data.data.participantVO.addressLine3 == null) || (data.data.participantVO.addressLine3 == '')) ? null : data.data.participantVO.addressLine2;
        this.address3 = ((data.data.participantVO.addressLine3 == null) || (data.data.participantVO.addressLine3 == '')) ? data.data.participantVO.addressLine2 : data.data.participantVO.addressLine3;
        this.stateCode = data.data.participantVO.stateCode;
        if (this.stateCode != null && this.stateCode != '') {
          this.state = this.states.get(this.stateCode);
        } else {
          this.state = '53';
        }
        this.zip = data.data.participantVO.zipCode;
        this.country = data.data.participantVO.country;
        if (this.country == 'OTHER/NON-USA') {
          ZipControl.clearValidators();
          StateControl.clearValidators();
          this.Is_US = false;
          this.is_dropdownUS = false;
        } else if (this.country == 'UNITED STATES') {
          ZipControl.setValidators([Validators.required, zipCustomValidation]);
          StateControl.setValidators([Validators.required]);
          this.is_dropdownUS = true;
          this.Is_US = true;
          if (data.data.participantVO.zipCode != null) {
            var output = [data.data.participantVO.zipCode.slice(0, 5), '-', data.data.participantVO.zipCode.slice(5)].join('');
            if ((data.data.participantVO.zipCode.length >= 6) && !(data.data.participantVO.zipCode.includes("-"))) {
              this.editForm.patchValue({
                zipCode: output
              })
            } else {
              this.editForm.patchValue({
                zipCode: data.data.participantVO.zipCode.slice(0, 5)
              })
            }
          }
        }
        this.spinner.hide();
        this.editForm.patchValue({
          participantId: data.data.participantVO.t2ParticipantId,
          firstName: this.firstName,
          middleName: data.data.participantVO.secondInitial,
          lastName: data.data.participantVO.lastName,
          gender: data.data.participantVO.gender,
          dob: data.data.participantVO.dateOfBirth,
          sdob: spDOBDB,
          workphnum: data.data.participantVO.workTelephoneNo,
          homephnum: data.data.participantVO.homeTelephoneNo,
          address1: data.data.participantVO.addressLine1,
          address2: this.address2,
          address3: this.address3,
          state: data.data.participantVO.stateCode,
          country: data.data.participantVO.country
        });
      }
    );
  }


  onCountryChange(CountryValue) {
    this.isError = false;
    const ZipControl = this.editForm.get('zipCode');
    const StateControl = this.editForm.get('state');
    if (CountryValue == 'UNITED STATES') {
      ZipControl.setValidators([Validators.required, zipCustomValidation]);
      StateControl.setValidators([Validators.required]);
      this.Is_US = true;
      this.is_dropdownUS = true;
    }
    else {
      ZipControl.clearValidators();
      StateControl.clearValidators();
      this.Is_US = false;
      this.is_dropdownUS = false;
    }
    if (this.country == CountryValue) {
      this.editForm.patchValue({
        zipCode: this.zip,
        state: this.stateCode,
        address1: this.address1,
        address2: this.address2,
        address3: this.address3
      });
    } else {
      this.editForm.patchValue({
        zipCode: null,
        state: null,
        address1: null,
        address2: null,
        address3: null
      });
    }
  }
  getStatusColor() {
    return this.msgColor;
  }

  private profileForm() {
    this.editForm = this.formBuilder.group({
      participantId: ['', Validators.required],
      firstName: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(15),
        Validators.minLength(1)
      ])),
      middleName: [''],
      lastName: ['', [Validators.required, Validators.maxLength(21), Validators.minLength(2), lastNameCustomValidation]],
      gender: ['', Validators.required],
      dob: [{ value: '', disabled: true }],
      sdob: [null, [sdobValidation]],
      homephnum: [''],
      workphnum: [''],
      country: ['', Validators.required],
      address1: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(35),
        Validators.minLength(1)
      ])),
      address2: [''],
      address3: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(35),
        Validators.minLength(1)
      ])),
      state: [''],
      zipCode: [null]
    });
  }
  private loginForm() {
    this.resetPasswordForm = this.formBuilder.group({
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(64),
        Validators.minLength(8),
        Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[A-Za-z0-9]+$')

      ])),
      confirmPassword: ['', [Validators.required, passwordConfirming]]
    });
  }
}

